export default __webpack_public_path__ + "571a4d9bfb1b68cdba5ce87e645bd16c.svg";